import {ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation} from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'admin-app',
  styles: [ require('./admin-app.component.css') ],
  template: require('./admin-app.component.html')
})
export class AdminAppComponent implements OnInit {

  isBrowser: boolean;

  constructor(@Inject('isBrowser') isBrowser: boolean){
    this.isBrowser = isBrowser;
  }

  ngOnInit(): void {
    if(this.isBrowser){
      document.getElementsByTagName("html")[0].style["font-size"] = "10px";
    }
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+admin-app/admin-app.component.ts